function mergeObject(base = {}, incoming = {}) {
  if (!base || typeof base !== "object") return { ...(incoming || {}) };
  if (!incoming || typeof incoming !== "object") return { ...(base || {}) };

  return {
    ...base,
    ...incoming,
  };
}

export function normalizeBookingDraft(raw = {}) {
  const source = raw && typeof raw === "object" ? raw : {};
  const measurements = mergeObject(source.measurements || {}, source.measurements || {});
  const fabric = mergeObject(source.fabric || {}, source.fabric || {});
  const delivery = mergeObject(source.delivery || {}, source.delivery || {});
  const selectedAddOns = Array.isArray(source.selectedAddOns)
    ? source.selectedAddOns
    : Array.isArray(source.addOns?.selected)
      ? source.addOns.selected
      : [];

  if (!measurements.manualValues && source.manualMeasurements) {
    measurements.manualValues = source.manualMeasurements;
  }
  if (!measurements.values && source.measurements?.values) {
    measurements.values = source.measurements.values;
  }
  if (!measurements.method && source.measurementMethod) {
    measurements.method = source.measurementMethod;
  }
  if (!measurements.selectedSize && source.selectedSize) {
    measurements.selectedSize = source.selectedSize;
  }

  if (!fabric.option && source.fabricOption) {
    fabric.option = source.fabricOption;
  }

  if (!delivery.addressSnapshot && source.addressSnapshot) {
    delivery.addressSnapshot = source.addressSnapshot;
  }

  return {
    ...source,
    measurements,
    fabric,
    delivery,
    selectedAddOns,
    specialInstructions: source.specialInstructions ?? source.instructions ?? null,
    updatedAt: new Date().toISOString(),
  };
}

export function readBookingDraft() {
  try {
    const parsed = JSON.parse(sessionStorage.getItem("stichb_booking_draft") || "{}");
    return normalizeBookingDraft(parsed);
  } catch {
    return normalizeBookingDraft({});
  }
}

export function updateBookingDraft(values) {
  const current = readBookingDraft();
  const next = normalizeBookingDraft({
    ...current,
    ...(values && typeof values === "object" ? values : {}),
    measurements: mergeObject(current.measurements || {}, values?.measurements || {}),
    fabric: mergeObject(current.fabric || {}, values?.fabric || {}),
    delivery: mergeObject(current.delivery || {}, values?.delivery || {}),
    selectedAddOns: Array.isArray(values?.selectedAddOns)
      ? values.selectedAddOns
      : Array.isArray(values?.addOns?.selected)
        ? values.addOns.selected
        : current.selectedAddOns || [],
    updatedAt: new Date().toISOString(),
  });

  sessionStorage.setItem("stichb_booking_draft", JSON.stringify(next));
  window.dispatchEvent(new CustomEvent("stichb:booking-draft", { detail: next }));
  return next;
}

export function clearBookingDraft() {
  const draft = normalizeBookingDraft({});
  sessionStorage.setItem("stichb_booking_draft", JSON.stringify(draft));
  window.dispatchEvent(new CustomEvent("stichb:booking-draft", { detail: draft }));
  return draft;
}
